<div class="mc-hd">
  <h2>Mis mascotas</h2>
  <a class="mc-more" [routerLink]="['/mis-mascotas']">Ver todas</a>
</div>

<div class="mm-pets">

  <app-pet-card *ngFor="let pet of visibles; let i = index"
                [pet]="pet"
                [indice]="i"
                [proximaVacuna]="vacunaDe(pet)"
                [textoAccion]="textoAccion(pet)">
  </app-pet-card>

  <a class="mm-pet mm-new" [routerLink]="['/add-pet']">
    <span class="mm-plus">+</span>
    Agregar una mascota
  </a>

</div>
